<script>

  import util from './SgsUtils'

  export default{
    props: [
      "attr", "fieldValue"
    ]
  }
</script>

<template>
  <div v-show="false">
    <el-input
      placeholder="Hidden"
      v-model="fieldValue"
      :readonly="true"
    />
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderInputHidden.vue?73df59ef